@import '../../../../../../../../constants/spacing.module.less';
@import '~style-sheet-helpers/core.less';

.initial-import-wrapper {
  margin: 0 auto;
  padding: @space-24 @space-0;
  min-height: 400px;
}

.title-row {
  margin-bottom: @space-16;
  align-items: flex-start;
  gap: @space-8;
}

.recommended-badge {
  background-color: var(--gray-818F9C);
  color: var(--white);
  padding: @space-4 @space-8;
  border-radius: 3px;
  margin-top: @space-4;
}

.description-text {
  margin-bottom: @space-24;
  color: var(--grey-900);
  text-align: left;
}

.steps-card {
  background-color: var(--white);
  border: 1px solid var(--gray-E4E5E7);
  border-radius: 8px;
  padding: @space-24;
}

.main-layout {
  width: 100%;
  display: flex;
}

.instructions-column {
  flex: 1;
  margin-right: @space-24;
}

.upload-column {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.step-header {
  align-items: center;
  margin-bottom: @space-20;
  padding-bottom: @space-16;
  border-bottom: 1px solid var(--gray-E4E5E7);
}

.step-item {
  margin-bottom: @space-20;
  flex-wrap: nowrap;
  text-align: left;

  &:last-child {
    margin-bottom: 0;
  }
}

.step-content {
  width: 100%;
  align-items: flex-start;
}

.check-icon {
  color: var(--green-05B45E);
  font-size: 14px;
  margin-top: 5px;
  flex-shrink: 0;
  margin-right: @space-8;
  margin-left: @space-24;
  width: 14px;
  height: 14px;
}

.clipboard-icon {
  color: var(--gray-637381);
  font-size: 16px;
  margin-top: 2px;
  margin-right: @space-8;
  width: 16px;
  height: 16px;
}

.chevron-icon {
  margin-left: @space-4;
  height: 16px;
  width: 16px;
}

.view-all-button {
  align-items: center;
  gap: @space-4;
}

.view-all-dropdown {
  display: inline-block;
}

.view-only-item {
  pointer-events: none;
  cursor: default;
}

.fields-list {
  margin-top: @space-12;
}

.field-item {
  align-items: center;
  margin-bottom: @space-8;
  gap: @space-4;
}

.required-text {
  color: var(--red-FF4422);
  font-weight: 500;
}

.optional-text {
  color: var(--gray-637381);
  font-style: italic;
}

.upload-area {
  flex: 1;
}

.custom-drop-area {
  flex: 1;
}

.hidden-warehouse {
  margin-top: @space-24;
}

.dropdown-title {
  margin-top: @space-16;
  text-align: left;
}

.header {
  font-weight: 700;
}

.dropdown-optional-message {
  font-weight: @normal;
  margin-left: @space-4;
  color: var(--default--disabled--text-color--4);
}

.default-dropdown-item {
  color: var(--default--disabled--text-color--4);
}

.dropdown-wrapper {
  max-width: 50%;
  align-items: start;
  gap: @space-4;
  padding: 0 0 @space-24 @space-24;
}

.dropdown-menu {
  width: 100%;
}

.warehouse-dropdown {
  margin-top: @space-12;
  width: 100%;
}

.create-new-item {
  border-bottom: 1px solid var(--gray-E4E5E7);
  padding: @space-8 @space-12;
}

.add-warehouse-wrapper {
  text-align: left;
  max-width: 835px;
  margin: 0 auto;
  padding: 0 @space-24 @space-24;
}

.add-warehouse-title {
  margin-top: @space-24;
}

.add-warehouse-description {
  margin-top: @space-4;
  color: var(--gray-56595D);
}

.add-warehouse-button {
  margin-top: @space-16;
}

.initial-import-step {
  text-align: left;
}

.ftu-description {
  font-size: 16px;
}
